export const canAccessPage = (loginTime) => new Date().getTime() - new Date(loginTime).getTime() < 5*60*1000;
